<template>
  <carousel
    class="carousel__description"
    ref="carouselSelector"
    :navigationEnabled="true"
    :per-page="1"
    :pagination-enabled="true"
    :loop="true"
    :autoplay="true"
    :autoplay-timeout="5000"
    navigationNextLabel='<img  class="banner__pass-des direita-d" src="/img/direita.png" />'
    navigationPrevLabel='<img  class="banner__pass-des esquerda-d" src="/img/esquerda.png" />'
  >
    <slide class="slide" align="center" v-for="(item, index) in items" :key="index">
      <div class="container">
        <div class="row">
          <div class="banner__image" :style="'background-image: url(' + item.image + ')'"></div>
        </div>
      </div>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["items"],
  data() {
    return {
      width: screen.width,
      banner1: "http://localhost/img/description.png",
      banner2: "http://localhost/img/description.png",
      banner3: "http://localhost/img/description.png",
    };
  },
  components: {
    Carousel,
    Slide,
  },
  methods: {
    navigateTo(index) {
      this.slider = index;
      this.$refs.carouselSelector.goToPage(index);
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs["carouselSelector"].onResize();
      this.$refs["carouselSelector"].goToPage(0);
    }, 200);
  },
};
</script>

<style lang="scss" rel="stylesheet" media="all">
@import "resources/assets/sass/website/_variables.scss";

.carousel__description {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  position: relative;
  .slide {
    position: relative;
  }
  .banner__image {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
    width: 98%;
    height: 600px;
    @media (max-width: 1500px) {
      height: 520px;
    }
    @media (max-width: 996px) {
      height: 475px;
    }
    @media (max-width: 775px) {
      height: 350px;
    }
    @media (max-width: 550px) {
      height: 300px;
    }
    @media (max-width: 500px) {
      height: 260px;
    }
  }
  .banner__description {
    margin-top: 50px;
    width: 400px;
    margin-left: -100px;
    @media (max-width: 756px) {
      margin-left: -220px;
      width: 300px;
    }
    @media (max-width: 560px) {
      margin-left: -350px;
    }
    @media (max-width: 500px) {
      width: 200px;
      margin-left: -100px;
    }
    @media (max-width: 400px) {
      width: 150px;
      margin-left: -40px;
    }
    h6 {
      color: $white;
      font-family: $font-geo;
      font-style: normal;
      font-weight: 510;
      font-size: 35px;
      line-height: 45px;
      text-align: left;
      @media (max-width: 756px) {
        font-size: 30px;
        line-height: 30px;
      }
      @media (max-width: 500px) {
        font-size: 18px;
        line-height: 20px;
      }
    }
    .banner__description-name {
      color: $pink;
      font-family: $font-geo;
      font-style: normal;
      font-weight: normal;
      font-size: 19px;
      line-height: 140%;
      text-align: right;
      @media (max-width: 756px) {
        margin-right: 150px;
      }
      @media (max-width: 500px) {
        font-size: 15px;
        margin-right: -50px;
      }
      @media (max-width: 390px) {
        margin-right: 0px;
      }
    }
    p {
      color: $white;
      font-family: $font-geo;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 140%;
      text-align: right;
      width: 300px;
      margin-right: -50px;
      @media (max-width: 756px) {
        margin-right: 150px;
      }
      @media (max-width: 500px) {
        margin-right: -50px;
        font-size: 12px;
        width: 150px;
      }
      @media (max-width: 390px) {
        margin-right: 0px;
      }
    }
  }
}
.VueCarousel-dot[data-v-438fd353]:focus {
  outline: none;
}
.VueCarousel-navigation-button[data-v-453ad8cd]:focus {
  outline: none;
}
.VueCarousel-pagination .VueCarousel-dot {
  background-color: #3d3839 !important;
}
.VueCarousel-pagination .VueCarousel-dot--active {
  background-color: #6c6264 !important;
}
.VueCarousel-navigation-next[data-v-453ad8cd]:focus {
  outline: none;
  border: none;
  box-shadow: none;
}
.banner__pass-d {
  margin-top: -15px;
  @media (max-width: 1500px) {
    margin-top: 50px;
  }
  @media (max-width: 996px) {
    margin-top: -200px;
    max-width: 50px;
    max-height: 50px;
  }
  @media (max-width: 775px) {
    margin-top: 0px;
  }
  @media (max-width: 600px) {
    max-width: 30px;
    max-height: 30px;
  }
}
.direita-d {
  @media (max-width: 575px) {
    margin-left: -25px;
  }
}
.esquerda-d {
  @media (max-width: 575px) {
    margin-right: -55px;
  }
}
.banner__pass-des {
  margin-top: -15px;
  @media (max-width: 1500px) {
    margin-top: 50px;
  }
  @media (max-width: 996px) {
    margin-top: 0px;
    max-width: 50px;
    max-height: 50px;
  }
  @media (max-width: 775px) {
    margin-top: 0px;
  }
  @media (max-width: 600px) {
    max-width: 30px;
    max-height: 30px;
  }
  @media (max-width: 450px) {
    display: none;
  }
}

.VueCarousel-dot-container {
  align-items: center;
  display: flex !important;
  flex-direction: row !important;
  justify-content: center;
  margin-top: -40px !important;
}
.VueCarousel-pagination {
  display: none;
  @media (max-width: 450px) {
    display: block;
  }
}
.VueCarousel-navigation-button,
.VueCarousel-navigation-next,
.VueCarousel-navigation-prev {
  z-index: 10;
}
</style>
